import React, { memo, useEffect } from 'react';
import { useFocus } from 'js/hooks/useFocus';

export const TableRow = memo(({ cells = [], classNames, isFocused = false, tableRowId }) => {
    const [rowRef, setFocus] = useFocus();

    useEffect(() => {
        if (isFocused) {
            setFocus();
        }
    }, [isFocused, setFocus]);

    return cells.length
        ? (
            <div
                ref={rowRef}
                data-table-row-id={tableRowId}
                className={classNames.tableRowContainer || ''}
                { ...isFocused ? { tabIndex: 0 } : null}
            >
                {cells.map(cell => (
                    <span
                        key={cell.id}
                        className={`${cell.className || ''} ${classNames.tableRowColumn || ''}`}
                    >
                    {cell.content}
                </span>
                ))}
            </div>
        ) : null;
    }
);

